export const ROLES = {
  Owner: 1,
  Admin: 2,
  Editor: 3,
  Viewer: 4,
  Generic: 5,
  NoAccess: 6,
};
export const ADMIN_ROLE_IDS = new Set([1, 2, 11, 12]);
